<template>
  <div>
    <reportTypeSelector ref="reportTypeSelector" @algunReportSeleccionado="algunReportSeleccionado" />

    <el-button slot="reference" class="btn-primary-brains btn-brains-header ml-2" :disabled="!btn_generar_preview" @click="generarPreviewPDF()">{{
      $t("generate-report")
    }}</el-button>

    <el-button slot="reference" :disabled="!previewActive" class="btn-primary-brains btn-brains-header ml-2" @click="initPrintPDF()">{{
      $t("download-report")
    }}</el-button>
  </div>
</template>
<script>
import reportTypeSelector from '@/components/reportSelector.vue'
import html2pdf from 'html2pdf.js'
import html2canvas from 'html2canvas'
import { mapState } from 'vuex'
export default {
  name: 'ReportFilter',
  components: { reportTypeSelector },
  data() {
    return {
      currentZoomLevelMap: 'Province',
      btn_generar_preview: false,
      previewActive: false
    }
  },
  computed: {
    ...mapState('location', {
      geolevelselected: (state) => state.geolevelselected,
      geolevels: (state) => state.geolevels
    }),
    selectedReportsOptions: {
      get() {
        return this.$store.state['reports'].selectedReportsOptions
      },
      set(value) {
        this.$store.dispatch('reports/setSelectedReportsOptions', { value: value })
      }
    },
    idPaisActual() {
      return this.geolevels.filter((item) => item.level === 0)[0].id
    }
  },
  watch: {
    geolevelselected(newOne, oldOne) {
      if (this.firstLoad) {
        if (newOne.id !== oldOne.id) {
          this.generarPreviewPDF()
        }
      }
    },
    previewActive(newOne, oldOne) {
      if (!newOne) {
        this.$refs.reportTypeSelector.restartReports()
      }
    }
  },
  methods: {
    algunReportSeleccionado(value) {
      this.btn_generar_preview = value
    },
    async makeScreenshot() {
      return new Promise((resolve, reject) => {
        const node = document.querySelector('.data-page-report--chart')
        node.style.fontFeatureSettings = '"liga" 0'

        html2canvas(node, { useCORS: false, foreignObjectRendering: false, fontFamily: 'Montserrat-Regular' }).then(function(canvas) {
          console.log(canvas)
          resolve(canvas.toDataURL())
        })
      })
    },
    async testFotoCharts() {
      const screenshot = await this.makeScreenshot() // png dataUrl
      const img = document.querySelector('.screen')
      img.src = screenshot
    },
    initPrintPDF() {
      this.$root.$emit('manageLoadingPrint', true)
      this.$root.$emit('initPrint', true)

      var paginas = document.getElementsByClassName('page-pdf')

      paginas.forEach(pagina => {
        pagina.classList.remove('mb-2')
        pagina.style.border = 'none'
      })

      setTimeout(() => {
        this.generatePDF()
      }, 2000)
    },
    endPrintPDF() {
      var paginas = document.getElementsByClassName('page-pdf')

      paginas.forEach(pagina => {
        pagina.classList.add('mb-2')
        pagina.style.border = '1px solid black'
      })

      this.$root.$emit('manageLoadingPrint', false)
      this.$root.$emit('initPrint', false)
    },
    generarPreviewPDF() {
      const vm = this
      this.firstLoad = true
      this.$root.$emit('manageLoadingPrint', true)
      var reportkeys = this.selectedReportsOptions.map((report) => {
        return report.id
      })
      var mapkeys = this.selectedReportsOptions.map((report) => {
        return report.map_id
      })
      var country_name = this.geolevels.filter((item) => item.level === 0)[0].name
      vm.$store
        .dispatch('reports/loadReportCharts', {
          geolevel: this.geolevelselected,
          reportkeys: reportkeys,
          country_name: country_name,
          mapkeys: mapkeys,
          countryid: this.idPaisActual,
          allgeolevels: this.geolevels
        })
        .then((res) => {
          vm.$root.$emit('generarPreviewPDF')
          vm.$root.$emit('manageLoadingPrint', false)
          vm.previewActive = true
        })
    },
    async generatePDF() {
      var element = document.getElementById('container-col-pdf-data')

      var opt = {
        margin: [10, 20, 0, 10],
        filename: 'brains-report.pdf',
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 2 },
        pagebreak: { mode: 'avoid-all' },
        jsPDF: {
          unit: 'px',
          format: [1410, 795],
          // format: [1880, 1060],
          // format: [1400, 800],
          orientation: 'landscape'
        }
      }

      html2pdf()
        .set(opt)
        .from(element)
        .toPdf()
        .save()
        .then(() => {
          this.endPrintPDF()
        })
    }
  }
}
</script>
